module.exports = __webpack_public_path__ + "img/Alumni-IMGCopy.d2713777.jpg";